import i18n from "i18next";
import type { FC } from "react";

import type { TerminalVersionList } from "src/app/features/TerminalVersion/types/TerminalVersionList";
import { SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import type { Datasource } from "../../../../../components/Table/types/Datasource";

interface CheckAllAffectedButtonProps extends ButtonProps<TerminalVersionList> {
    onRowSelectionChange?: (rows: TerminalVersionList[]) => void;
    datasource?: Datasource<TerminalVersionList>;
}

export const CheckAllAffectedButton: FC<CheckAllAffectedButtonProps> = ({ datasource, onRowSelectionChange }) => {
    const callback = () => {
        const affectedItems = datasource?.data
            .filter((terminalVersion: TerminalVersionList) => terminalVersion.affected)
            .map((terminalVersion: TerminalVersionList) => ({ ...terminalVersion, key: terminalVersion.id as string }));

        if (onRowSelectionChange && affectedItems) {
            onRowSelectionChange(affectedItems);
        }
    };

    return (
        <SecondaryButton name="checkAffected_button" onClick={callback} disabled={false}>
            {i18n.t("button.checkAffected")}
        </SecondaryButton>
    );
};
